import React from 'react';

function KnobButtonSVG() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="22" fill="white" />
      <path
        d="M15 18H29"
        stroke="#0082D6"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 26H29"
        stroke="#0082D6"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default KnobButtonSVG;
